;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { TourId } from "@/features/onboarding-tours/types/tour-definition";
import type {
	ObjectivesState,
	PipelineState,
	TourRunsState,
} from "@/features/onboarding-tours/types/tour-persistence";

export interface PipelineContext {
	isVisualizationGuardActive: boolean;
	canInvite: boolean;
}

export interface PipelineEvaluationInput {
	objectives: ObjectivesState;
	tourRuns: TourRunsState;
	pipeline: PipelineState;
	context: PipelineContext;
}

export interface PipelineStepDefinition {
	id: string;
	tourId: TourId;
	when: (input: PipelineEvaluationInput) => boolean;
	framing?: "default" | "add-more-providers";
}

export const ONBOARDING_PIPELINE: PipelineStepDefinition[] = [
	{
		id: "guard",
		tourId: "add-data-provider-guard",
		when: ({ objectives, context, pipeline }) =>
			!objectives.hasDataProvider &&
			context.isVisualizationGuardActive &&
			!pipeline.guardHandoffDone,
	},
	{
		id: "invite",
		tourId: "invite-team-member",
		when: ({ tourRuns, pipeline, context }) =>
			pipeline.guardHandoffDone &&
			context.canInvite &&
			!tourRuns["invite-team-member"]?.completedAt &&
			!tourRuns["invite-team-member"]?.dismissedAt,
	},
];

export function getNextPipelineStep({
	input,
}: {
	input: PipelineEvaluationInput;
}): PipelineStepDefinition | null {
	for (const step of ONBOARDING_PIPELINE) {
		if (step.when(input)) {
			return step;
		}
	}
	return null;
}

export function applyPipelineTourEnd({
	pipeline,
	tourId,
	reason,
}: {
	pipeline: PipelineState;
	tourId: TourId;
	reason: "complete" | "skip";
}): PipelineState {
	if (tourId === "add-data-provider-guard" && reason === "complete") {
		return {
			...pipeline,
			guardHandoffDone: true,
		};
	}

	if (tourId === "add-data-provider-settings") {
		return {
			...pipeline,
			settingsTourDone: true,
		};
	}

	return pipeline;
}
